import { name, version } from '../package.json';

export default {
    dismissIconAriaLabel: {
        type: String,
        default: 'Dismiss',
        docs: {
            validation: '—',
            description: 'Sets the `aria-label` attribute on the dismiss button.',
        },
    },
    list: {
        type: Array,
        validator: items => items.every(item => typeof item === 'string'),
        docs: {
            validation: '—',
            description: 'Sets list content of the alert.',
        },
    },
    persistent: {
        type: Boolean,
        default: false,
        docs: {
            validation: '—',
            description: 'If `true`, removes the dismiss button.',
        },
    },
    size: {
        type: String,
        default: 'medium',
        validator(value) {
            return ['small', 'medium'].indexOf(value) !== -1;
        },
        docs: {
            validation: 'One of: `small`, `medium`.',
            description: 'Sets the size of the alert.',
        },
    },
    text: {
        type: String,
        docs: {
            validation: '**Required**',
            description: 'The text that appears in the alert. Can also be passed via the default slot.',
        },
    },
    tinted: {
        type: Boolean,
        default: false,
        docs: {
            validation: '—',
            description: 'If `true`, adds the tinted background color to the body of the alert.',
        },
    },
    title: {
        type: String,
        docs: {
            validation: '—',
            description: 'Sets the title of the alert.',
        },
    },
    variation: {
        type: String,
        default: 'informational',
        validator(value) {
            return ['error', 'warning', 'informational', 'success'].indexOf(value) !== -1;
        },
        docs: {
            validation: 'One of: `error`, `warning`, `success`, `informational`.',
            description: 'Sets the variation of the alert.',
        },
    },
    version: {
        type: String,
        default: `${name}-${version}`,
        docs: {
            validation: 'Read-only',
            description:
                'Set automatically by package version, do not manually adjust this prop. Used to add a data attribute providing the component version to the component markup rendered in the DOM.',
        },
    },
};
